define('gameInterfaces/pages/PlayNGoGameInterface',['knockout', 'underscore'], function(ko, _) {

    function PlayNGoGameInterface(RealityCheckViewModel, navigation) {

        var self = this,
            source = window.parent;

        self.realityCheckViewModel = new RealityCheckViewModel(self);

        self.canActivate = function() {
            return self.realityCheckViewModel.canActivate();
        };

        self.continuePlaying = function() {
            postMessage({
                req: 'gameEnable'
            });
        };

        self.exitToLobby = function() {
            postMessage({
                req: 'gameEnd',
                data: {
                    redirectUrl: navigation.reverseRouteAbsolute(navigation.ROUTES.GAMES)
                }
            });
        };

        self.exitToGameRoundHistory = function() {
            postMessage({
                req: 'gameEnd',
                data: {
                    redirectUrl: navigation.reverseRouteAbsolute(navigation.ROUTES.HISTORY_BETS)
                }
            });
        };

        self.compositionComplete = function() {

            self.realityCheckViewModel.realityCheck.subscribe(_.skipFalsy(function() {
                postMessage({req: 'gameDisable'});
            }));

            window.addEventListener(
                'message',
                handleReceivedMessage,
                false
            );

        };

        function postMessage(msg) {
            source.postMessage(msg, '*');
        }

        function handleReceivedMessage(e) {

            switch (e.data.type) {
                case 'init':
                    // This needs to be listened to before the initial page load
                    // which is incompatible with our async module loading
                    break;

                case 'gameDisabled':
                    // No need to do anything
                    break;

                case 'gameEnabled':
                    // No need to do anything
                    break;
            }
        }

    }

    return PlayNGoGameInterface;

});

